//@flow
import withUsers from "./withUsers"
import withUserFormDetails from "./withUserFormDetails"
import mutateUpdateUser from "./mutateUpdateUser"
import mutateCreateUser from "./mutateCreateUser"
import mutateDeleteUser from "./mutateDeleteUser"

const queries = {
  withUsers,
  withUserFormDetails,
  mutateCreateUser,
  mutateUpdateUser,
  mutateDeleteUser
}

export default queries



// WEBPACK FOOTER //
// ./src/Users/queries/index.js